import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {Router} from '@angular/router';
import {UtilsInjectable} from '@app/shared';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-add-price',
  templateUrl: './add-price.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    NgOptimizedImage
  ],
  styleUrls: ['./add-price.component.scss']
})
export class AddPriceComponent implements OnInit {

  public pricing_list: any =
    {
      customer_name: [""],
      customer_id: "",
      date: new Date(),
      medicine_id: [""],
      slab_a_amount: [""],
      slab_b_amount: [""],
      slab_c_amount: [""],
      slab_a_check: [""],
      slab_b_check: [""],
      slab_c_check: [""],
      check: [""],
      dates: [""],
      mrp: [""],
      purchase_details_id: [""]

    }


  user_rights: any;
  user_data: any;
  closeResult = "";
  discount_list: any;
  customer: any[] = [];
  status: any;

  customer_data: any;
  print_data: any;
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  config = {
    displayKey: "CUSTOMER_NAME",
    search: true,
    height: 'auto',
    placeholder: 'Select Customer',

    limitTo: 10,
    moreText: '.........',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'CUSTOMER_NAME'
  }

  constructor(private loaderService: LoaderService,
              public consultingService: ConsultingService,
              private toastr: ToastrService,
              private router: Router,
              private utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listAllItems();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listAllItems() {

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listAllItems().subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.discount_list = result['data'];
        this.addCheck();
        this.loaderService.display(false);
        this.print();

      } else {
        this.loaderService.display(false);
      }
    });
  }

  public saveAddPrice(): any {
    if (this.pricing_list.customer_id == '' || this.pricing_list.customer_id == null) {
      this.toastr.success( 'Please enter Customer !');
      return false;
    }
    let i = 0;
    for (const data of this.discount_list) {

      this.pricing_list.medicine_id[i] = data.MEDICINE_ID
      this.pricing_list.purchase_details_id[i] = data.PURCHASE_DETAILS_ID
      this.pricing_list.mrp[i] = data.MRP
      this.pricing_list.slab_a_amount[i] = data.SLAB_A_AMOUNT
      this.pricing_list.slab_b_amount[i] = data.SLAB_B_AMOUNT
      this.pricing_list.slab_c_amount[i] = data.SLAB_C_AMOUNT
      this.pricing_list.slab_a_check[i] = data.A_CHECK
      this.pricing_list.slab_b_check[i] = data.B_CHECK
      this.pricing_list.slab_c_check[i] = data.C_CHECK
      this.pricing_list.check[i] = data.CHECKED
      this.pricing_list.customer_name[i] = this.pricing_list.customer_id
      this.pricing_list.dates[i] = this.utils.date(this.pricing_list.date)

      i = i + 1
    }
    this.loaderService.display(true);
    this.consultingService.saveAddPrice(this.pricing_list).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result['msg'])
        this.loaderService.display(false);
        this.router.navigate(['pricing-list/price-list']).then();

      } else {
        this.toastr.error(result['msg'])
        this.loaderService.display(false);
      }
    });
  }

  addCheck() {
    let i = 0;
    for (const data of this.discount_list) {
      data["CHECKED"] = true;
      data["A_CHECK"] = true;
      data["B_CHECK"] = false;
      data["C_CHECK"] = false;
      this.discount_list[i] = data;
      i = i + 1;
    }
    this.print();
  }

  updateChecked(_: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        data.CHECKED = data.CHECKED == false;
      }
    }
  }

  updateAChecked(_i: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.A_CHECK == false) {
          data.A_CHECK = true;
          data.B_CHECK = false;
          data.C_CHECK = false
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  updateBChecked(_i: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.B_CHECK == false) {
          data.A_CHECK = false;
          data.B_CHECK = true;
          data.C_CHECK = false;
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  updateCChecked(_i: any, id: any) {
    for (const data of this.discount_list) {
      if (data.PURCHASE_DETAILS_ID == id) {
        if (data.C_CHECK == false) {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = true;
        } else {
          data.A_CHECK = false;
          data.B_CHECK = false;
          data.C_CHECK = false;
        }
      }
    }
  }

  public print() {
    const value: any = [];
    value["CUSTOMER_NAME"] = this.pricing_list.customer_name
    value["DATE"] = this.pricing_list.date
    this.print_data = this.discount_list.map((o: any): any => {
      if (o.CHECKED == true) {
        return {
          "TRADE_NAME": o.TRADE_NAME,
          "SLAB_A_AMOUNT": o.SLAB_A_AMOUNT,
          "SLAB_B_AMOUNT": o.SLAB_B_AMOUNT,
          "SLAB_C_AMOUNT": o.SLAB_C_AMOUNT,
          "A_CHECK": o.A_CHECK,
          "B_CHECK": o.B_CHECK,
          "C_CHECK": o.C_CHECK,
        };
      }

    });
    this.print_data.push(value);
  }


}
